import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class PostsGroupPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'addPostsPosts':
        return this.permissions.add_posts

      case 'updatePostsGroup':
        return this.permissions.update

      case 'archivePostsGroup':
        return this.permissions.archive

      case 'manageParticipantsPostsGroup':
        return this.permissions.manage_participants

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default PostsGroupPolicy
